(function($, Drupal) {
  'use strict';

  Drupal.behaviors.remove_association_modal = {
    attach: function(context, settings) {
      let $popup = $('.remove-association-modal');

      if ($popup.length) {
        const closeModal = function() {
          $popup.hide();
          document.body.style.overflow = 'auto';
        };

        $('.remove-association-close').click(function() {
          closeModal();
        });

        $('.remove-association').on('click', function() {
          let $form_association = $('#edit-association');
          let $form_user = $('#edit-user');
          let $form_associationid = $('#edit-associationid');
          $form_association.val($(this).data('association'));
          $form_user.val($(this).data('user'));
          $form_associationid.val($(this).data('associationid'));

          $popup.css('display', 'flex');
          $('.remove-association-close').first().blur();
          document.body.style.overflow = 'hidden';

          // focus trap
          let $focusable = $popup.find('a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])');
          let $first = $focusable.first();
          let $last = $focusable.last();
          $first.focus();
          $last.on('keydown', function(e) {
            if ((e.which === 9 && !e.shiftKey)) {
              e.preventDefault();
              $first.focus();
            }
          });
          $first.on('keydown', function(e) {
            if ((e.which === 9 && e.shiftKey)) {
              e.preventDefault();
              $last.focus();
            }
          });
        });

        $('#edit-cancel').on('click', function(event) {
          event.preventDefault();
          closeModal();
        });
      }
    }
  };
})(jQuery, Drupal);
